var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"z-index":"999999"}},[_c('span',{staticStyle:{"color":"#1890ff"},on:{"click":function($event){$event.stopPropagation();return _vm.getData.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.code||'--'))]),_c('BatchProductionModal',{ref:"BatchProductionModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }